export default "__VITE_ASSET__D60irS$r__"